/**
 * The cloud a whole change of look passes under (ui-actions `veiled`): it drifts in, covers the canvas while the change
 * is made, and drifts on, showing the new look. Never in the way: it takes no touch.
 */
import { useUi } from '../../react/hooks';
import css from './Overlays.module.css';

export function Veil() {
  const veil = useUi((u) => u.veil);
  return veil ? <div key={veil} className={css.veil} data-veil aria-hidden /> : null;
}
